<template>
  <div class="guide">
    <div class="distributed-header">
      <div class="distributed-logo"></div>
      <span class="school">大赛导览</span>
      <span class="word">Competition Guide</span>
      <div class="header-bottom"></div>
    </div>
    <div class="guide-box">
      <div class="unit">
        <div class="unit-header">
          <span class="icon"></span>
          <span class="title">协办单位</span>
        </div>
        <div class="info">
          <div class="info-title">重庆木棉树软件开发有限公司</div>
        </div>
      </div>
      <div class="unit">
        <div class="unit-header header">
          <span class="icon"></span>
          <span class="title">报到时间</span>
        </div>
        <div class="info">
          <div class="info-title">2021年12月10日</div>
        </div>
      </div>
      <div class="unit-box">
        <div class="unit-header header">
          <span class="icon"></span>
          <span class="title">赛事日程</span>
        </div>
        <div class="info project">
          <div
            class="info-title"
            v-for="(item, index) in competitionItem"
            :key="index"
          >
            <span>{{ item.title }}</span
            ><span>{{ item.time }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "guide",
  data() {
    return {
      competitionItem: [
        {
          title: "裁判员培训时间",
          time: "2021(12.12-12.14)",
        },
        {
          title: "选手适应场地和理论考试时间",
          time: "2021(12.13-12.14)",
        },
        {
          title: "开幕时间",
          time: "2021(12.15)",
        },
        {
          title: "比赛时间",
          time: "2021(12.15-12.18)",
        },
        {
          title: "闭幕时间",
          time: "2021(12.19)",
        }
      ],
    };
  },
};
</script>

<style scoped>
.guide {
  width: 100%;
  height: 100%;
  background: url("./../../../assets/img/guide-bg.png") no-repeat;
  background-size: 100% 100%;
}
.distributed-header {
  width: 100%;
  height: 9.5%;
  position: relative;
  box-sizing: border-box;
  padding-left: 0.05rem;
  display: flex;
}
.header-bottom {
  position: absolute;
  bottom: 0px;
  width: 100%;
  height: 1px;
  background: url("./../../../assets/img/distributed-line.png") no-repeat;
  background-size: 100% 100%;
}
.distributed-header .distributed-logo {
  margin-top: 1.5%;
  width: 0.6375rem;
  background: url("./../../../assets/img/distributed-logo.png") no-repeat;
  background-size: 100% 100%;
}
.distributed-header .school {
  font-size: 0.225rem;
  font-family: "pmzd";
  display: flex;
  align-items: center;
  margin: 0 0.0625rem;
   background-image: -webkit-linear-gradient(bottom, #7db2ff, #ffffff);
  -webkit-background-clip: text;
  color: transparent;
}
.distributed-header .word {
  font-family: "SourceHanSansCN";
  color: #9cc3ff;
  font-size: 0.15rem;
  margin-top: 1.5%;
}
.guide-box {
  width: 100%;
  height: 90.5%;
  font-size: 0.175rem;
  font-family: "SourceHanSansCN";
  box-sizing: border-box;
  overflow: hidden;
}
.unit {
  height: 18%;
  box-sizing: border-box;
}
.unit .unit-header {
  width: 100%;
  padding-left: 0.0625rem;
  overflow: hidden;
}
.unit .unit-header .icon {
  display: inline-block;
  width: 0.1125rem;
  height: 0.1375rem;
  background: url("./../../../assets/img/icon.png") no-repeat;
}
.unit .unit-header .title {
  color: #9cc3ff;
  margin-left: 0.0625rem;
}
.unit .info {
  height: 50%;
  display: flex;
  justify-content: center;
}
.unit .info .info-title {
  width: 4rem;
  background: url("./../../../assets/img/guide-list.png") no-repeat;
  background-size: 100% 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 100%;
  color: #fff;
  overflow: hidden;
  white-space: nowrap;
}
.unit-box {
  height: 88%;
  overflow: hidden;
}
.unit-box .unit-header {
  padding-left: 0.0625rem;
  overflow: hidden;
}
.unit-box .unit-header .icon {
  display: inline-block;
  width: 0.1125rem;
  height: 0.1375rem;
  background: url("./../../../assets/img/icon.png") no-repeat;
}
.unit-box .unit-header .title {
  color: #9cc3ff;
  margin-left: 0.0625rem;
}
.unit-box .info {
  height: 64%;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  overflow: hidden;
}
.unit-box .info::-webkit-scrollbar {
  width: 3px;
  display: none;
}
.unit-box .info .info-title {
  height: 16%;
  width: 4rem;
  background: url("./../../../assets/img/guide-list.png") no-repeat;
  background-size: 100% 100%;
  display: flex;
  align-items: center;
  overflow: hidden;
  white-space: nowrap;
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  color: #fff;
  box-sizing: border-box;
  padding: 0 0.05rem;
}
</style>